//import library
import moment from "moment";
import "bootstrap-daterangepicker";
import "./style.scss";

class DateRangePicker {
  constructor(selector, startDateSelector, endDateSelector, options = {}) {
    const DEFAULT_OPTIONS = {
      autoApply: false,
      ranges: {
        Bugün: [moment().format("DD.MM.YYYY"), moment().format("DD.MM.YYYY")],
        "Önceki Gün": [
          moment().subtract(1, "days").format("DD.MM.YYYY"),
          moment().subtract(1, "days").format("DD.MM.YYYY"),
        ],
        "Son 2 Gün": [
          moment().subtract(1, "days").format("DD.MM.YYYY"),
          moment().format("DD.MM.YYYY"),
        ],
        "Son 7 Gün": [
          moment().subtract(6, "days").format("DD.MM.YYYY"),
          moment().format("DD.MM.YYYY"),
        ],
        "Son 30 Gün": [
          moment().subtract(29, "days").format("DD.MM.YYYY"),
          moment().format("DD.MM.YYYY"),
        ],
        "Bu Ay": [
          moment().startOf("month").format("DD.MM.YYYY"),
          moment().endOf("month").format("DD.MM.YYYY"),
        ],
        "Geçen Ay": [
          moment().subtract(1, "month").startOf("month").format("DD.MM.YYYY"),
          moment().subtract(1, "month").endOf("month").format("DD.MM.YYYY"),
        ],
      },
      locale: {
        format: "DD.MM.YYYY",
        separator: " - ",
        applyLabel: "Onayla",
        cancelLabel: "Vazgeç",
        fromLabel: "Tarih Aralığı",
        toLabel: "-",
        customRangeLabel: "Tarih Seç",
        weekLabel: "H",
        daysOfWeek: ["Pa", "Pts", "Sa", "Çar", "Per", "Cu", "Cts"],
        monthNames: [
          "Oca",
          "Şub",
          "Mar",
          "Nis",
          "May",
          "Haz",
          "Tem",
          "Ağu",
          "Eyl",
          "Eki",
          "Kas",
          "Ara",
        ],
        firstDay: 1,
      },
      alwaysShowCalendars: false,
      startDate: moment().format("DD.MM.YYYY"),
      endDate: moment().format("DD.MM.YYYY"),
      opens: "left",
    };

    this.elements = document.querySelectorAll(selector);
    this.options = Object.assign({}, DEFAULT_OPTIONS, options);
    this.startDate = startDateSelector;
    this.endDate = endDateSelector;
    this.displayDate = displayDate;
  }

  init() {
    this.elements.forEach((item) => {
      $(item).daterangepicker(this.options);
      $(item).on("apply.daterangepicker", (e, picker) => {
        $(this.startDate).val(
          picker.startDate.format("YYYY-MM-DD 00:00:00.000000"),
        );
        $(this.endDate).val(
          picker.endDate.format("YYYY-MM-DD 23:59:59.9999999"),
        );
      });

      const displayElement = document.querySelector(
        item.dataset.displayElement,
      );

      if (displayElement.value != "") {
        $(item).data("daterangepicker").setStartDate($(this.startDate).val());
        $(item).data("daterangepicker").setEndDate($(this.endDate).val());
      }
    });
  }
}

export default DateRangePicker;
